import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Typewriter = ({ text, speed = 50 }) => {
  const [displayText, setDisplayText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setDisplayText(prev => prev + text[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, speed);
      
      return () => clearTimeout(timeout);
    }
  }, [currentIndex, text, speed]);

  return <span>{displayText}</span>;
};

export default function Home() {
  const [currentRole, setCurrentRole] = useState(0);
  
  const roles = [
    "Senior Software Engineer",
    "Java & Spring Boot Expert",
    "Microservices Architect",
    "Full Stack Developer",
    "System Design Specialist"
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentRole((prev) => (prev + 1) % roles.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [roles.length]); // Fixed: Added roles.length as dependency

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 text-white relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/4 left-1/4 w-72 h-72 bg-purple-500 rounded-full mix-blend-multiply filter blur-xl animate-blob"></div>
        <div className="absolute top-1/3 right-1/4 w-72 h-72 bg-yellow-500 rounded-full mix-blend-multiply filter blur-xl animate-blob animation-delay-2000"></div>
        <div className="absolute bottom-1/4 left-1/2 w-72 h-72 bg-pink-500 rounded-full mix-blend-multiply filter blur-xl animate-blob animation-delay-4000"></div>
      </div>

      {/* Main Content */}
      <section className="relative flex-1 flex items-center justify-center py-20 px-4 z-10">
        <div className="max-w-6xl text-center space-y-8">
          {/* Animated Quote */}
          <div className="inline-block bg-white/10 backdrop-blur-md rounded-2xl px-8 py-4 border border-white/20">
            <p className="text-xl md:text-2xl italic text-indigo-200 font-light">
              "Make it work, make it right, make it fast."
            </p>
          </div>

          {/* Name with Gradient */}
          <div>
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-extrabold mb-4 bg-gradient-to-r from-blue-400 via-purple-500 to-pink-400 bg-clip-text text-transparent">
              Braj Bhushan Kumar
            </h1>
            
            {/* Animated Role */}
            <div className="h-12 mb-6">
              <h2 className="text-xl md:text-3xl font-semibold text-indigo-200 transition-all duration-500">
                <Typewriter text={roles[currentRole]} speed={80} />
              </h2>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-2xl mx-auto">
            <div className="bg-white/10 backdrop-blur-md rounded-xl p-4 border border-white/20">
              <div className="text-2xl font-bold text-white">8+</div>
              <div className="text-sm text-indigo-200">Years Experience</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-xl p-4 border border-white/20">
              <div className="text-2xl font-bold text-white">10+</div>
              <div className="text-sm text-indigo-200">Projects</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-xl p-4 border border-white/20">
              <div className="text-2xl font-bold text-white">5G</div>
              <div className="text-sm text-indigo-200">Telecom Systems</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-xl p-4 border border-white/20">
              <div className="text-2xl font-bold text-white">Full</div>
              <div className="text-sm text-indigo-200">Stack</div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-8">
            <Link
              to="/projects"
              className="group bg-gradient-to-r from-blue-500 to-purple-600 text-white px-8 py-4 rounded-full font-semibold hover:shadow-2xl transition-all duration-300 transform hover:scale-105 hover:-translate-y-1 flex items-center space-x-2"
            >
              <span>View My Work</span>
              <span className="group-hover:translate-x-1 transition-transform">🚀</span>
            </Link>
            <Link
              to="/contact"
              className="group border-2 border-white/30 text-white px-8 py-4 rounded-full font-semibold hover:bg-white/10 transition-all duration-300 transform hover:scale-105 flex items-center space-x-2"
            >
              <span>Get In Touch</span>
              <span className="group-hover:scale-110 transition-transform">💬</span>
            </Link>
          </div>
        </div>
      </section>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/70 rounded-full mt-2"></div>
        </div>
      </div>
    </div>
  );
}